angular.module('cfn').directive('bookingDate', [
  'bookingActivitiesService',
  function(bookingActivitiesService) {
    return {
      restrict: 'E',
      templateUrl: require('./bookingDate.html'),
      controller: [
        '$scope',
        function($scope) {
          $scope.bookingDateDirective = {
            startDate: $scope.$parent.details ? $scope.$parent.details.startDate : null,
            endDate: $scope.$parent.details ? $scope.$parent.details.endDate : null
          };

          $scope.$on('bookingDatesChanged', function(event, model) {
            $scope.details.startDate = model.startDate;
            $scope.details.endDate = model.endDate;
            $scope.details.allDay = false;
          });

          $scope.$watch('bookingDateDirective.startDate', function(newValue) {
            if (newValue && !angular.isDate(newValue)) {
              $scope.details.startDate = new Date(newValue);
            }
          });

          $scope.$watch('bookingDateDirective.endDate', function(newValue) {
            if (newValue && !angular.isDate(newValue)) {
              $scope.details.endDate = new Date(newValue);
            }
          });

          $scope.$watch('details.startDate', function(newValue, oldValue) {
            if (newValue === oldValue || $scope.details.state === 'TEMPLATE')
              return;
            if (newValue) $scope.bookingDateDirective.startDate = newValue;
            if ($scope.details.endDate && $scope.details.startDate) {
              let endDateLinked =
                $scope.details.endDate.getTime() ===
                  $scope.details.startDate.getTime() || $scope.details.allDay;
              if (endDateLinked) {
                // endDate auf startDate setzen. Uhrzeit beibehalten
                let hourBefore = new Date($scope.details.endDate).getHours();
                let minuteBefore = new Date(
                  $scope.details.endDate
                ).getMinutes();
                let newVal = new Date($scope.details.startDate);
                newVal.setHours(hourBefore);
                newVal.setMinutes(minuteBefore);
                $scope.details.endDate = newVal;
              }
              $scope.validateDatePeriod(
                $scope,
                $scope.details.startDate,
                $scope.details.endDate,
                $scope.details.allDay
              );
            }
          });

          $scope.$watch('details.endDate', function(newValue, oldValue) {
            if (newValue === oldValue || $scope.details.state === 'TEMPLATE')
              return;
            if (newValue) $scope.bookingDateDirective.endDate = newValue;
            // New booking-Entry? Set state
            if (
              $scope.details &&
              $scope.details.endDate &&
              $scope.details.id === null
            ) {
              if ($scope.details.endDate < new Date()) {
                $scope.details.state = 'PRELIMINARY';
              } else {
                $scope.details.state = 'INPLANNING';
              }
            }
            $scope.validateDatePeriod(
              $scope,
              $scope.details.startDate,
              $scope.details.endDate,
              $scope.details.allDay
            );
          });

          $scope.$watch('details.allDay', function(newValue, oldValue) {
            if (newValue === oldValue || $scope.details.state === 'TEMPLATE')
              return;
            //set time +24h if allDay is set
            if (newValue) {
              $scope.details.startDate.setHours(0, 0, 0, 0);
              $scope.details.endDate = $scope.details.startDate;
            }

            $scope.validateDatePeriod(
              $scope,
              $scope.details.startDate,
              $scope.details.endDate,
              $scope.details.allDay
            );
          });

          $scope.validateDatePeriod = function(
            $scope,
            startDate,
            endDate,
            allDays
          ) {
            let result = true;
            if (startDate && endDate) {
              if (!allDays) {
                result = startDate.getTime() < endDate.getTime();
              }
            }
            $scope.details.validSelectedDatePeriod = result;
          };
        }
      ]
    };
  }
]);
